import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

// ─── Async Thunks ───

// CRO Audit (Kit 00)
export const fetchCroAudit = createAsyncThunk('kitData/fetchCroAudit', async (_, { rejectWithValue }) => {
  try {
    const res = await api.get('/kit-data/cro-audit');
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to fetch'); }
});

export const saveCroAudit = createAsyncThunk('kitData/saveCroAudit', async (payload, { rejectWithValue }) => {
  try {
    const res = await api.put('/kit-data/cro-audit', payload);
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to save'); }
});

// Creative Brief (Kit 03)
export const fetchCreativeBrief = createAsyncThunk('kitData/fetchCreativeBrief', async (_, { rejectWithValue }) => {
  try {
    const res = await api.get('/kit-data/creative-brief');
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to fetch'); }
});

export const saveCreativeBrief = createAsyncThunk('kitData/saveCreativeBrief', async (formData, { rejectWithValue }) => {
  try {
    const res = await api.put('/kit-data/creative-brief', formData);
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to save'); }
});

// Store Audit (Kit 04)
export const fetchStoreAudit = createAsyncThunk('kitData/fetchStoreAudit', async (_, { rejectWithValue }) => {
  try {
    const res = await api.get('/kit-data/store-audit');
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to fetch'); }
});

export const saveStoreAudit = createAsyncThunk('kitData/saveStoreAudit', async (scores, { rejectWithValue }) => {
  try {
    const res = await api.put('/kit-data/store-audit', { scores });
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to save'); }
});

// Paid Media Audit (Kit 05)
export const fetchPaidMediaAudit = createAsyncThunk('kitData/fetchPaidMediaAudit', async (_, { rejectWithValue }) => {
  try {
    const res = await api.get('/kit-data/paid-media-audit');
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to fetch'); }
});

export const savePaidMediaAudit = createAsyncThunk('kitData/savePaidMediaAudit', async (payload, { rejectWithValue }) => {
  try {
    const res = await api.put('/kit-data/paid-media-audit', payload);
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to save'); }
});

// Kit 06-07-08 Audits
export const fetchKit06078Audit = createAsyncThunk('kitData/fetchKit06078Audit', async (_, { rejectWithValue }) => {
  try {
    const res = await api.get('/kit-data/kit-06078-audit');
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to fetch'); }
});

export const saveKit06078Audit = createAsyncThunk('kitData/saveKit06078Audit', async (payload, { rejectWithValue }) => {
  try {
    const res = await api.put('/kit-data/kit-06078-audit', payload);
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to save'); }
});

// Kit 15-18 Frameworks
export const fetchKit1518Data = createAsyncThunk('kitData/fetchKit1518Data', async (_, { rejectWithValue }) => {
  try {
    const res = await api.get('/kit-data/kit-1518');
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to fetch'); }
});

export const saveKit1518Data = createAsyncThunk('kitData/saveKit1518Data', async (data, { rejectWithValue }) => {
  try {
    const res = await api.put('/kit-data/kit-1518', { data });
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to save'); }
});

// Kit 19-25 Flows/SOPs
export const fetchKit1925Data = createAsyncThunk('kitData/fetchKit1925Data', async (_, { rejectWithValue }) => {
  try {
    const res = await api.get('/kit-data/kit-1925');
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to fetch'); }
});

export const saveKit1925Data = createAsyncThunk('kitData/saveKit1925Data', async (data, { rejectWithValue }) => {
  try {
    const res = await api.put('/kit-data/kit-1925', { data });
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to save'); }
});

// AI Implementation Audit
export const fetchAiAudit = createAsyncThunk('kitData/fetchAiAudit', async (_, { rejectWithValue }) => {
  try {
    const res = await api.get('/kit-data/ai-audit');
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to fetch'); }
});

export const saveAiAudit = createAsyncThunk('kitData/saveAiAudit', async (payload, { rejectWithValue }) => {
  try {
    const res = await api.put('/kit-data/ai-audit', payload);
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to save'); }
});

// AEO/GEO Audit
export const fetchAeoGeoAudit = createAsyncThunk('kitData/fetchAeoGeoAudit', async (_, { rejectWithValue }) => {
  try {
    const res = await api.get('/kit-data/aeo-geo-audit');
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to fetch'); }
});

export const saveAeoGeoAudit = createAsyncThunk('kitData/saveAeoGeoAudit', async (payload, { rejectWithValue }) => {
  try {
    const res = await api.put('/kit-data/aeo-geo-audit', payload);
    return res.data.data;
  } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to save'); }
});

// ─── Slice ───

const kitDataSlice = createSlice({
  name: 'kitData',
  initialState: {
    croAudit: null,
    creativeBrief: null,
    storeAudit: null,
    paidMediaAudit: null,
    kit06078Audit: null,
    kit1518Data: null,
    kit1925Data: null,
    aiAudit: null,
    aeoGeoAudit: null,
    loading: false,
    saving: false,
    error: null,
  },
  reducers: {
    clearKitError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    // CRO Audit
    builder.addCase(fetchCroAudit.pending, (state) => { state.loading = true; });
    builder.addCase(fetchCroAudit.fulfilled, (state, action) => { state.loading = false; state.croAudit = action.payload; });
    builder.addCase(fetchCroAudit.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder.addCase(saveCroAudit.pending, (state) => { state.saving = true; });
    builder.addCase(saveCroAudit.fulfilled, (state, action) => { state.saving = false; state.croAudit = action.payload; });
    builder.addCase(saveCroAudit.rejected, (state, action) => { state.saving = false; state.error = action.payload; });

    // Creative Brief
    builder.addCase(fetchCreativeBrief.pending, (state) => { state.loading = true; });
    builder.addCase(fetchCreativeBrief.fulfilled, (state, action) => { state.loading = false; state.creativeBrief = action.payload; });
    builder.addCase(fetchCreativeBrief.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder.addCase(saveCreativeBrief.pending, (state) => { state.saving = true; });
    builder.addCase(saveCreativeBrief.fulfilled, (state, action) => { state.saving = false; state.creativeBrief = action.payload; });
    builder.addCase(saveCreativeBrief.rejected, (state, action) => { state.saving = false; state.error = action.payload; });

    // Store Audit
    builder.addCase(fetchStoreAudit.pending, (state) => { state.loading = true; });
    builder.addCase(fetchStoreAudit.fulfilled, (state, action) => { state.loading = false; state.storeAudit = action.payload; });
    builder.addCase(fetchStoreAudit.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder.addCase(saveStoreAudit.pending, (state) => { state.saving = true; });
    builder.addCase(saveStoreAudit.fulfilled, (state, action) => { state.saving = false; state.storeAudit = action.payload; });
    builder.addCase(saveStoreAudit.rejected, (state, action) => { state.saving = false; state.error = action.payload; });

    // Paid Media Audit
    builder.addCase(fetchPaidMediaAudit.pending, (state) => { state.loading = true; });
    builder.addCase(fetchPaidMediaAudit.fulfilled, (state, action) => { state.loading = false; state.paidMediaAudit = action.payload; });
    builder.addCase(fetchPaidMediaAudit.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder.addCase(savePaidMediaAudit.pending, (state) => { state.saving = true; });
    builder.addCase(savePaidMediaAudit.fulfilled, (state, action) => { state.saving = false; state.paidMediaAudit = action.payload; });
    builder.addCase(savePaidMediaAudit.rejected, (state, action) => { state.saving = false; state.error = action.payload; });

    // Kit 06-07-08
    builder.addCase(fetchKit06078Audit.pending, (state) => { state.loading = true; });
    builder.addCase(fetchKit06078Audit.fulfilled, (state, action) => { state.loading = false; state.kit06078Audit = action.payload; });
    builder.addCase(fetchKit06078Audit.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder.addCase(saveKit06078Audit.pending, (state) => { state.saving = true; });
    builder.addCase(saveKit06078Audit.fulfilled, (state, action) => { state.saving = false; state.kit06078Audit = action.payload; });
    builder.addCase(saveKit06078Audit.rejected, (state, action) => { state.saving = false; state.error = action.payload; });

    // Kit 15-18
    builder.addCase(fetchKit1518Data.pending, (state) => { state.loading = true; });
    builder.addCase(fetchKit1518Data.fulfilled, (state, action) => { state.loading = false; state.kit1518Data = action.payload; });
    builder.addCase(fetchKit1518Data.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder.addCase(saveKit1518Data.pending, (state) => { state.saving = true; });
    builder.addCase(saveKit1518Data.fulfilled, (state, action) => { state.saving = false; state.kit1518Data = action.payload; });
    builder.addCase(saveKit1518Data.rejected, (state, action) => { state.saving = false; state.error = action.payload; });

    // Kit 19-25
    builder.addCase(fetchKit1925Data.pending, (state) => { state.loading = true; });
    builder.addCase(fetchKit1925Data.fulfilled, (state, action) => { state.loading = false; state.kit1925Data = action.payload; });
    builder.addCase(fetchKit1925Data.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder.addCase(saveKit1925Data.pending, (state) => { state.saving = true; });
    builder.addCase(saveKit1925Data.fulfilled, (state, action) => { state.saving = false; state.kit1925Data = action.payload; });
    builder.addCase(saveKit1925Data.rejected, (state, action) => { state.saving = false; state.error = action.payload; });

    // AI Audit
    builder.addCase(fetchAiAudit.pending, (state) => { state.loading = true; });
    builder.addCase(fetchAiAudit.fulfilled, (state, action) => { state.loading = false; state.aiAudit = action.payload; });
    builder.addCase(fetchAiAudit.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder.addCase(saveAiAudit.pending, (state) => { state.saving = true; });
    builder.addCase(saveAiAudit.fulfilled, (state, action) => { state.saving = false; state.aiAudit = action.payload; });
    builder.addCase(saveAiAudit.rejected, (state, action) => { state.saving = false; state.error = action.payload; });

    // AEO/GEO Audit
    builder.addCase(fetchAeoGeoAudit.pending, (state) => { state.loading = true; });
    builder.addCase(fetchAeoGeoAudit.fulfilled, (state, action) => { state.loading = false; state.aeoGeoAudit = action.payload; });
    builder.addCase(fetchAeoGeoAudit.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder.addCase(saveAeoGeoAudit.pending, (state) => { state.saving = true; });
    builder.addCase(saveAeoGeoAudit.fulfilled, (state, action) => { state.saving = false; state.aeoGeoAudit = action.payload; });
    builder.addCase(saveAeoGeoAudit.rejected, (state, action) => { state.saving = false; state.error = action.payload; });
  },
});

export const { clearKitError } = kitDataSlice.actions;
export default kitDataSlice.reducer;
